<template>
    <div class="teams">
        <Navbar />
        <v-container>
            <v-layout row wrap>
                <v-dialog v-model="dialog" max-width="500px">
                    <v-btn slot="activator" color="primary" dark class="mb-2">New Team</v-btn>
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>
                        <v-form v-model="validForm" lazy-validation>
                            <v-card-text>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <v-flex xs12>
                                            <v-text-field v-model="editedTeam.name" label="Name" required :rules="nameRules"></v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-select :items="teamTypes" v-model="editedTeam.type" label="Type" :rules="selectRules"
                                                required></v-select>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-select :items="makeup_centers" v-model="editedTeam.makeup_center" label="Makeup Center"></v-select>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-checkbox v-model="editedTeam.medivac" label="Medivac"></v-checkbox>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" flat @click.native="close">Cancel</v-btn>
                                <v-btn :disabled="!validForm" color="blue darken-1" flat @click.native="save">Save</v-btn>
                            </v-card-actions>
                        </v-form>
                    </v-card>
                </v-dialog>

                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
            </v-layout>
            <v-data-table :items="teams" :headers="headers" class="elevation-1" :search="search" :custom-filter="filterItems"
                :rows-per-page-items='[10,25,{"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}]'>
                <template slot="items" slot-scope="props">
                    <td @click="openTeam(props.item)">{{ props.item.name }}</td>
                    <td @click="openTeam(props.item)">{{ props.item.type }}</td>
                    <td @click="openTeam(props.item)">{{ props.item.makeup_center }}</td>
                    <td @click="openTeam(props.item)">
                        <v-icon small v-if="props.item.medivac">done</v-icon>
                        <v-icon small v-if="!props.item.medivac">clear</v-icon>
                    </td>
                    <td class="justify-center layout px-0">
                        <v-icon small class="mr-2" @click="editTeam(props.item)">
                            edit
                        </v-icon>
                        <v-icon small @click="deleteTeam(props.item)">
                            delete
                        </v-icon>
                    </td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                </v-alert>
            </v-data-table>
        </v-container>

        <v-snackbar v-model="newTeamCantCreate" :right="true">
            Team can't be created.
            <v-btn color="pink" flat @click="newTeamCantCreate = false">
                Close
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Navbar from '@/components/Navbar.vue'
    import axios from 'axios';
    axios.defaults.baseURL = process.env.VUE_APP_BACKEND_URL;

    export default {
        name: 'teams',
        data() {
            return {
                search: '',
                teams: [],
                dialog: false,
                newTeamCantCreate: false,
                editedIndex: -1,
                teamTypes: ['AMP', 'AMPS', 'EMT 1', 'EMT 1 mobile', 'EMT 2', 'EMT 3', 'other'],
                makeup_centers: [1, 2, 3, 4, 5],
                headers: [{
                        text: 'Name',
                        align: 'left',
                        value: 'name'
                    },
                    {
                        text: 'Type',
                        value: 'type'
                    },
                    {
                        text: 'Makeup Center',
                        vale: 'makeup_center'
                    },
                    {
                        text: 'MEDIVAC',
                        value: 'medivac'
                    },
                ],
                eID: this.$route.params.e_id,
                editedTeam: {
                    id: '',
                    name: '',
                    type: '',
                    makeup_center: null,
                    medivac: false,
                    exercise_id: this.$route.params.e_id
                },
                defaultTeam: {
                    id: '',
                    name: '',
                    type: '',
                    makeup_center: null,
                    medivac: false,
                    exercise_id: this.$route.params.e_id
                },
                validForm: false,
                nameRules: [
                    v => !!v || 'Name is required',
                    v => (v && v.length <= 50) || 'Name must be less than 50 characters'
                ],
                selectRules: [
                    v => !!v || 'Type is required'
                ]
            }
        },
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? 'New Team' : 'Edit Team'
            }
        },
        components: {
            Navbar
        },
        methods: {
            filterItems(items, search, filter) {
                if (!search) {
                    return items
                }
                //Split search in array
                let needleAry = search.toString().toLowerCase().split(" ").filter(x => x.trim().length > 0);

                function myFilter(item, search) {
                    return filterName(item, search) || filterType(item, search) || filterMedivac(item, search)
                }

                function filterName(item, search) {
                    return item.name != null &&
                        item.name.toLowerCase().includes(search)
                }

                function filterType(item, search) {
                    return item.type != null &&
                        item.type.toLowerCase().includes(search)
                }

                function filterMedivac(item, search) {
                    if ('medivac'.includes(search)) {
                        return item.medivac
                    }
                    return false
                }


                return items.filter(row => needleAry.every(needle => myFilter(row, needle)))
            },
            fetchTeams() {
                axios.get('/exercises/' + this.eID + '/teams').then(response => {
                    this.teams = response.data.reverse()
                }).catch(error => {})
            },
            editTeam(team) {
                this.editedIndex = this.teams.indexOf(team)
                this.editedTeam = Object.assign({}, team)
                this.dialog = true
            },
            close() {
                this.dialog = false
                setTimeout(() => {
                    this.editedTeam = Object.assign({}, this.defaultTeam)
                    this.editedIndex = -1
                    this.validForm = false
                }, 300)
            },
            save() {
                if (this.editedTeam.id === '') {
                    this.createTeam(this.editedTeam);
                } else {
                    this.updateTeam(this.editedTeam);
                }
                this.close()
            },
            createTeam(team) {
                axios.post('/exercises/' + this.eID + '/teams', team).then(response => {
                    this.teams.unshift(response.data)
                }).catch(error => {
                    this.newTeamCantCreate = true
                });
            },
            updateTeam(team) {
                axios.put('/exercises/' + this.eID + '/teams', team).then(response => {
                    if (this.editedIndex != -1) {
                        Object.assign(this.teams[this.editedIndex], this.editedTeam)
                    }
                }).catch(error => {});
            },
            deleteTeam(team) {
                if (confirm('Are you sure you want to delete this team?')) {
                    axios.delete('/exercises/' + this.eID + '/teams', {
                        data: Object.assign({}, team)
                    }).then(response => {
                        this.teams.splice(this.teams.indexOf(team), 1);
                    }).catch(error => {})
                }

            },
            openTeam(team) {
                this.$router.push({
                    name: 'team',
                    params: {
                        id: team.id,
                        e_id: this.eID
                    }
                })
            }
        },
        mounted() {
            this.fetchTeams();
        }
    }
</script>